import * as React from "react";
const SvgChevronupG900 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path stroke="#191919" strokeLinecap="round" strokeLinejoin="round" d="m4 11 5-5 5 5" />
  </svg>
);
export default SvgChevronupG900;
